export default {
  left_column: {
    title: 'Verificar Saldo',
    description:
      'Introduza o código do seu cartão de oferta para verificar o saldo restante. O código pode ser encontrado no PDF do seu cartão de oferta.',
  },
  title: 'Verificar Saldo do Cartão de Oferta',
  subtitle: 'Introduza um código de cartão de oferta para verificar o saldo atual',
  error: {
    title: 'Oferta não encontrada!',
    description: 'Introduza um código de cartão de oferta válido.',
  },
  gift_card: {
    title: 'Cartão de oferta encontrado!',
    balance: 'Saldo',
    value: 'Valor',
    expires_at: 'Expira em',
  },
  form: {
    code: {
      label: 'Código do Cartão de Oferta',
    },
  },
  buttons: {
    check_balance: 'Verificar saldo',
  },
};
